module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUdwTP///////////////////////////////xb9HQ4AAAAIdFJOUwDgpEfp0XixoKUCRgAAADhJREFUGNNjYKAQqCOYTB0ItkYTkrACIeGMDghoA7JNOgTBIBjIZvYIQBhp0opg45FAcpsZ8d4AABRwDJ7pwYbEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/arrow-back.png
// module id = 1779
// module chunks = 0